import { useAuth0 } from "@auth0/auth0-react";
import ky from "ky";
import { useMemo } from "react";

export function useApi() {
  const { getAccessTokenSilently } = useAuth0();
  return useMemo(() => {
    return ky.extend({
      retry: 0, // Retry is handled by react-query
      timeout: false,
      prefixUrl: import.meta.env.VITE_API_URL,
      hooks: {
        beforeRequest: [
          async (request) => {
            const accessToken = await getAccessTokenSilently();
            request.headers.set("Authorization", `Bearer ${accessToken}`);
          },
        ],
      },
    });
  }, [getAccessTokenSilently]);
}
